import {
  Box,
  Button,
  CrudMode,
  Stack,
  Typography,
  ValidationErrors
} from "@compass/core";
import {
  Permission,
  PermissionAction,
  StudentServiceTemplate,
  StudentServiceTemplateAdditionalEntry,
  StudentServiceTemplateEditResource,
  StudentServiceTemplateViewResource
} from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { isAuthorized } from "services";
import { AdditionalEntry } from "./AdditionalEntry";

export const AdditionalEntries = (props: {
  rootPermission: Permission;
  crudMode: CrudMode;
  template: StudentServiceTemplate;
  entries: StudentServiceTemplateAdditionalEntry[];
  setEntries: (value: StudentServiceTemplateAdditionalEntry[]) => void;
  setEditMode: () => void;
  viewResource: StudentServiceTemplateViewResource;
  editResource: StudentServiceTemplateEditResource;
  validationErrors: ValidationErrors | string[];
}) => {
  return (
    <Stack spacing="sm" width="100%">
      {props.entries.length > 0 && (
        <Stack>
          {props.entries.map((entry, index) => (
            <Stack
              borderTop={index !== 0 ? "none" : "default"}
            >
              <AdditionalEntry
                crudMode={props.crudMode}
                rootPermission={props.rootPermission}
                entry={entry}
                setEntry={(value) =>
                  props.setEntries(
                    produce(props.entries, (draft) => {
                      draft[index] = value;
                    })
                  )
                }
                viewResource={props.viewResource}
                editResource={props.editResource}
                cancelCreate={() =>
                  props.setEntries(
                    produce(props.entries, (draft) => {
                      draft.splice(index, 1);
                    })
                  )
                }
                validationErrors={props.validationErrors[index] || []}
                setEditMode={props.setEditMode}
              />
            </Stack>
          ))}
        </Stack>
      )}

      <Box>
        {isAuthorized(props.rootPermission, PermissionAction.Create) && (

          <Stack direction="row" spacing="sm">
            <Button
              onClick={() =>
                props.setEntries(
                  produce(props.entries, (draft) => {
                    props.setEditMode();
                    draft.push({} as StudentServiceTemplateAdditionalEntry);
                  })
                )
              }
              variant="text"
              size="small"
            >
              <Typography variant="inherit" style={{ textTransform: "none" }}>
                + Additional Entry
              </Typography>
            </Button>

            <Button
              onClick={() =>
                props.setEntries(
                  produce(props.entries, (draft) => {
                    // copy the sevice type and subtype from top
                    draft.push({
                      serviceTypeId: props.template.serviceTypeId,
                      serviceSubTypeId: props.template.serviceSubTypeId,
                    } as StudentServiceTemplateAdditionalEntry);
                  })
                )
              }
              variant="text"
              size="small"
              sx={{ minWidth: "auto" }}
            >
              <Typography variant="inherit" style={{ textTransform: "none" }}>
                + Copy
              </Typography>
            </Button>
          </Stack>
        )}
      </Box>
    </Stack>
  );
};
